
import FacebookLogin from 'react-facebook-login';
import axios from 'axios';
import querystring from 'querystring';
import { toast } from "react-toastify"
import { useHistory, useLocation } from 'react-router-dom';

const CustomerFacebookLogin = () => {
    const history = useHistory();
    const location = useLocation();
    const nav_path = location.state?.nav_path || null;
 
    const responseFacebook = async (response) => {
      try {
        console.log("Facebook Login Response:", response);
        
        // Extract the access token
        const { accessToken, name, email } = response;
        
        // Send to backend using the same convention as your Google login
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}facebook-auth`,
          querystring.stringify({ 
            data: JSON.stringify({
              accessToken,
              name,
              email
            })
          })
        );
        
        console.log("Facebook Auth Response:", res.data);
        
        if (res.data.success) {          
            toast.success('Login successfully.', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            localStorage.setItem('auth_token',res?.data?.token);
            setTimeout(() => {
                if(nav_path) history.push(nav_path);
                else history.push('/customer-dashboard');
            }, 2500)  
        }
      } catch (error) {
        console.error("Facebook login error:", error);
        alert("Failed to authenticate with Facebook. Please try again.");
      }
    };
  
    return (
      <FacebookLogin
        appId="1201291371344392" // Replace with your Facebook App ID
        autoLoad={false}
        fields="name,email"
        callback={responseFacebook}
        icon="fa-facebook"
        textButton="Login with Facebook"
        cssClass="facebook-login-button"
      />
    );
  };
  
  export default CustomerFacebookLogin;
  